const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');

const ssoHost = publicConfig.external_address;

exports.Attendees = {
  create: function createAttendees (bookingId, status, token, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/attendees/rsvp/booking/${bookingId}/${status}`,
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(requestParams, (response) => {
      callback(response);
    }, null);
  },

  createInvites: function createAttendeeInvites (bookingId, payload, token, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/attendees/invites/booking/${bookingId}/emails`,
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(requestParams, (response) => {
      callback(response);
    }, payload);
  },

  read: function readAttendees (bookingId, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/attendees/rsvps/booking/${bookingId}`,
      method: 'GET'
    };

    httpLib.request(requestParams, (response) => {
      callback(response);
    }, null);
  },

  update: function updateAttendees (bookingId, status, token, callback) {
    const requestBody = { status };

    const requestParams = {
      host: ssoHost,
      path: `/v1/attendees/rsvp/booking/${bookingId}/${status}`,
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(requestParams, (response) => {
      callback(response);
    }, requestBody);
  }
};
